import { render, staticRenderFns } from "./traceManageDetailNew.vue?vue&type=template&id=7eece758&scoped=true&"
import script from "./traceManageDetailNew.vue?vue&type=script&lang=js&"
export * from "./traceManageDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./traceManageDetailNew.vue?vue&type=style&index=0&id=7eece758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eece758",
  null
  
)

export default component.exports